<template>
  <div class="channel-swiper">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in slides"
          :key="index"
        >
          <div class="slide-image-wrap" @click="goDetail(item.newsCode)">
            <img
              class="slide-image"
              referrerpolicy="no-referrer"
              :src="item.img"
              :alt="item.title"
              @load="handleCardImageLoad(index)"
              @error="handleCardImageError(index)"
            />
            <span v-if="!item.loaded && item.isLoading" class="img-placeholder">加载中...</span>
            <span v-if="item.error" class="img-default">暂无图片</span>
          </div>
          <div class="slide-info">
            <h3 class="slide-title" @click="goDetail(item.newsCode)">{{ item.title }}</h3>
            <div class="slide-source">{{ getSource(item.source) }} {{ formatTime(item.time) }}</div>
            <p class="slide-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>

      <!-- 左右箭头：使用腾讯同款 ruyi-icon -->
      <div class="swiper-button-prev swiper-nav-prev">
        <svg id="back-regular" class="ruyi-icon ruyi-icon-back-regular" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g fill="none">
            <path d="M15.4243 4.57573C15.6586 4.81004 15.6586 5.18994 15.4243 5.42426L8.84855 12L15.4243 18.5757C15.6586 18.81 15.6586 19.1899 15.4243 19.4243C15.19 19.6586 14.8101 19.6586 14.5758 19.4243L7.57576 12.4243C7.34145 12.1899 7.34145 11.81 7.57576 11.5757L14.5758 4.57573C14.8101 4.34142 15.19 4.34142 15.4243 4.57573Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>
          </g>
        </svg>
      </div>
      <div class="swiper-button-next swiper-nav-next">
        <svg id="chevron-right-regular" class="ruyi-icon ruyi-icon-chevron-right-regular" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g fill="none">
            <path d="M9 5L16 12L9 19" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
        </svg>
      </div>

      <!-- 底部分页点：文字区域底部 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Autoplay, Pagination, Navigation, EffectCreative } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/effect-creative/effect-creative.min.css'

export default {
  name: 'ChannelSwiper',
  
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiper: null,
      DEFAULT_IMAGE: 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'
    }
  },
  computed: {
    slides() {
      return this.items
    }
  },
  watch: {
    items(val) {
      if (val && val.length > 0) {
        this.$nextTick(() => this.initSwiper())
      }
    }
  },
  mounted() {
    if (this.slides.length > 0) {
      this.initSwiper()
    }
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
  },
  methods: {
    handleCardImageLoad(index) {
      this.$set(this.slides[index], 'loaded', true)
      this.$set(this.slides[index], 'isLoading', false)
    },
    handleCardImageError(index) {
      this.$set(this.slides[index], 'error', true)
      this.$set(this.slides[index], 'isLoading', false)
      this.$set(this.slides[index], 'img', this.DEFAULT_IMAGE)
    },
    
    
    goDetail(newsCode) {
      if (newsCode) {
        window.open(`/zp/a/${newsCode}`, '_blank')
      }
    },
    formatTime(timeStr) {
      if (!timeStr) return timeStr
      const now = new Date()
      const time = new Date(timeStr)
      const diffMs = now.getTime() - time.getTime()
      const diffSecs = Math.floor(diffMs / 1000)
      const diffMins = Math.floor(diffSecs / 60)
      const diffHours = Math.floor(diffMins / 60)
      const diffDays = Math.floor(diffHours / 24)

      if (diffDays > 0) {
        return `${diffDays}天前`
      } else if (diffHours > 0) {
        return `${diffHours}小时前`
      } else if (diffMins > 0) {
        return `${diffMins}分钟前`
      } else {
        return '刚刚'
      }
    },
    initSwiper() {
      this.swiper = new Swiper('.channel-swiper .swiper-container', {
        modules: [Autoplay, Pagination, Navigation, EffectCreative],
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ['-18%', 0, -400],
            rotate: [0, 0, 0],
            scale: 1,
            opacity: 1
          },
          next: {
            shadow: true,
            translate: ['18%', 0, -400],
            rotate: [0, 0, 0],
            scale: 1,
            opacity: 1
          }
        },
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        speed: 700
      })
    },
    getSource(source) {
      if (!source) return ''
      const truncated = source.split('|')[0]
      return this.truncateSevenChars(truncated)
    },
    truncateSevenChars(str) {
      if (!str) return ''
      if (str.length <= 7) return str
      return str.slice(0, 7) + '...'
    }
  }
}
</script>

<style scoped>
.channel-swiper {
  width: 100%;
  height: 360px;
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
}

.channel-swiper .swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.channel-swiper .swiper-slide {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background: #fff;
  overflow: hidden;
}

.slide-image-wrap {
  width: 640px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.slide-info {
  flex: 1;
  padding: 24px 30px 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f8f8f8;
  position: relative;
  margin-top: -120px;
}
/* 加载中状态 */
.img-loading {
  opacity: 0.3;
}

/* 图片占位符 - 居中显示 */
.img-placeholder,
.img-default {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #999;
  z-index: 1;
}
.slide-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  margin: 0 0 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.slide-source {
  font-size: 14px;
  color: #999;
  margin-bottom: 16px;
}

.slide-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* 分页点：文字区域底部左对齐 */
.channel-swiper .swiper-pagination {
  position: absolute;
  bottom: 18px;
  left: 640px;
  right: 0;
  width: auto;
  padding-left: 30px;
  text-align: left;
  z-index: 10;
}

.channel-swiper .swiper-pagination ::v-deep .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(0, 0, 0, 0.25);
  opacity: 1;
  margin: 0 5px;
  border-radius: 5px;
  transition: all 0.3s;
}

.channel-swiper .swiper-pagination ::v-deep .swiper-pagination-bullet-active {
  background: rgba(0, 0, 0, 0.7);
  width: 24px;
}

/* 左右箭头：复刻腾讯 ruyi-icon 样式 */
.channel-swiper .swiper-nav-prev,
.channel-swiper .swiper-nav-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  padding: 5px;
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  z-index: 10;
  transition: all 0.2s;
}

/* 左箭头：在图片区域，深色半透明底 + 白色图标 */
.channel-swiper .swiper-nav-prev {
  left: 10px;
  color: #fff;
  background-color: rgba(37, 37, 37, 0.5);
}

.channel-swiper .swiper-nav-prev:hover {
  background-color: rgba(37, 37, 37, 0.7);
}

/* 右箭头：在文字区域，透明底 + 深色图标 */
.channel-swiper .swiper-nav-next {
  right: 10px;
  color: rgba(0, 0, 0, 0.65);
  background-color: transparent;
}

.channel-swiper .swiper-nav-next:hover {
  color: rgba(0, 0, 0, 0.9);
  background-color: rgba(0, 0, 0, 0.06);
}

/* 隐藏 Swiper 默认的 ::after 箭头，只保留自定义 SVG */
.channel-swiper .swiper-button-prev::after,
.channel-swiper .swiper-button-next::after {
  display: none;
}

/* 覆盖 Swiper 默认导航按钮的禁用状态 */
.channel-swiper .swiper-button-disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
</style>
